import Icon from '@material-ui/icons/CheckCircle';
import InsList from './InsList'

export default {
    list: InsList,
    //edit: ShipmentEdit,
    //create: DonorCreate,
    icon: Icon,
};
